(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-product-families"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pf-family-controller')) {
  document.addEventListener('click', event => {
    const option = event.target.closest('[data-pf-option]');
    if (!option || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    const card = option.closest('.pf-family');
    const image = card.querySelector('.pf-family-image');
    image.removeAttribute('srcset');
    image.src = option.dataset.image;
    image.alt = option.dataset.alt;
    card.querySelectorAll('.pf-family-image-link,.pf-family-title').forEach(link => link.href = option.href);
    card.querySelector('.pf-family-price').textContent = option.dataset.price;
    card.querySelectorAll('[data-pf-option]').forEach(link => link.removeAttribute('aria-current'));
    option.setAttribute('aria-current','true');
  });
  customElements.define('pf-family-controller', class extends HTMLElement {});
}

  } catch(e) { console.error(e); }
})();
})();
